import { CheckoutState } from '../../state';
import {
    isEventbriteTLDInDevOrQAEnv,
    isIosWebView,
    isSafari,
    isSocialWebView,
} from '../../utils/browser';
import { isEventbriteTLD } from '../app';
import { getCanMakePaymentsWithGooglePay } from './pureSelectors';

export const isGooglePayAvailable = (state: CheckoutState) => {
    return (
        getCanMakePaymentsWithGooglePay(state) &&
        (isEventbriteTLD(state) || isEventbriteTLDInDevOrQAEnv()) &&
        !isIosWebView() &&
        !isSocialWebView() &&
        !isSafari()
    );
};
